/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-key */
import React from "react";
import { useState } from "react";
import "./styles.css";
import { Link } from "react-router-dom";

const defaultContentArray = [
  <Link to={"/"}>home</Link>,
  "",
  "",
  <Link to={"/contact"}>contact</Link>,
  <Link to={"/about"}>about</Link>,
  <Link to={"/resume"}>resume</Link>,
  <Link to={"/projects"}>projects</Link>,
  <Link to={"/blog"}>blog</Link>,
  "",
  "",
  "",
];
const Spine = ({ contentArray = defaultContentArray }) => {
  const [isOpen, setIsOpen] = useState(false);

  let openTimer = null;

  const toggleOpen = () => {
    const spineWidth = document.querySelector(".spine");
    spineWidth.classList.toggle("isOpen");
    setIsOpen(!isOpen);
  };

  const openSpine = () => {
    clearTimeout(openTimer);
    openTimer = setTimeout(() => {
      const spineWidth = document.querySelector(".spine");
      spineWidth.classList.add("isOpen");
      setIsOpen(true);
    }, 500);
  };

  const closeSpine = () => {
    clearTimeout(openTimer);
    openTimer = null;
    const spineWidth = document.querySelector(".spine");
    spineWidth.classList.remove("isOpen");
    setIsOpen(false);
  };

  const handleLinkClick = () => {
    if (window.innerWidth >= 768) {
      const spineWidth = document.querySelector(".spine");
      spineWidth.classList.add("isOpen");
      return;
    }
    toggleOpen();
  };

  return (
    <>
      <section
        className="spine"
        onMouseEnter={window.innerWidth >= 768 ? openSpine : null}
        onMouseLeave={window.innerWidth >= 768 ? closeSpine : null}
      >
        {contentArray.map((item, index) => (
          <React.Fragment key={index}>
            <div className="spine-section" onClick={handleLinkClick}>
              {item}
            </div>
          </React.Fragment>
        ))}
      </section>
    </>
  );
};

export default Spine;
